// Raw design tokens for BeforeVault Theme System
export const palette = {
  light: {
    bg: '#f8fafc',
    surface: '#ffffff',
    surface2: '#f8fafc',
    ink: '#1e293b',
    ink60: '#334155',
    ink40: '#8D8D8D',
    border: '#e2e8f0',
    divider: '#e2e8f0',
    appbarBg: '#ffffff',
    appbarShadow: 'rgba(0, 0, 0, 0.05)',
    drawerBg: '#ffffff',
    cardBg: '#ffffff',
    badgeBg: '#ffffff',
    heroGradient: 'linear-gradient(145deg, #e8f8fd 0%, #d6f4f0 40%, #ddf1fc 100%)',
    ctaSecondaryBg: 'rgba(255, 255, 255, 0.8)',
    ctaSecondaryColor: '#1a2b4a',
    ctaSecondaryBorder: 'rgba(26, 43, 74, 0.2)',
    subheadColor: '#2a3f60',
    benefitTextColor: '#2a3f60',
    catTitleColor: '#1a2b4a',
    catScenarioColor: '#4a6480',
    catOutcomeColor: '#0a7a60',
    badgeNameColor: '#1a2b4a',
    badgeNoteColor: '#7a9ab5',
    secureLineColor: '#7a9ab5',
  },
  dark: {
    bg: '#0b0f17',
    surface: '#111827',
    surface2: '#1a2234',
    ink: '#f8fafc',
    ink60: '#cbd5e1',
    ink40: '#94a3b8',
    border: 'rgba(255, 255, 255, 0.12)',
    divider: 'rgba(255, 255, 255, 0.12)',
    appbarBg: '#111827',
    appbarShadow: 'rgba(0, 0, 0, 0.5)',
    drawerBg: '#111827',
    cardBg: '#1a2234',
    badgeBg: '#1a2234',
    heroGradient: 'linear-gradient(180deg, #0f172a 0%, #0b0f17 100%)',
    ctaSecondaryBg: 'rgba(30, 41, 59, 0.85)',
    ctaSecondaryColor: '#f8fafc',
    ctaSecondaryBorder: 'rgba(255, 255, 255, 0.22)',
    subheadColor: '#cbd5e1',
    benefitTextColor: '#cbd5e1',
    catTitleColor: '#f8fafc',
    catScenarioColor: '#94a3b8',
    catOutcomeColor: '#00DCBC',
    badgeNameColor: '#f8fafc',
    badgeNoteColor: '#94a3b8',
    secureLineColor: '#94a3b8',
  },
  brand: {
    teal: '#00DCBC',
    tealDark: '#02B096',
    blue: '#18B4EC',
    topBannerBg: '#0f172a',
    footerBottomBg: '#2EBBED',
  },
};
